import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutShippingMethodsComponentDef } from '@df/checkout/checkout-shipping-methods.component.def';
import { App } from '@df/core/app';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { CheckoutDeliveryQuestionsComponent } from '../module/question/checkout-delivery-questions.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio';
import { CheckoutFormComponent } from './checkout-form.component';
import { CheckoutStepComponent } from './checkout-step.component';

declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface IShippingData {
            parcel_number?: number;
        }
    }
}

@Component({
    selector: 'checkout-shipping-methods',
    templateUrl: './checkout-shipping-methods.html',
    standalone: true,
    imports: [
        CheckoutDeliveryQuestionsComponent,
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        PriceComponent,
        RadioComponent,
        RadioGroupDirective,
        TranslatePipe
    ]
})
export class CheckoutShippingMethodsComponent extends CheckoutShippingMethodsComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        checkoutStepComponent: CheckoutStepComponent,
        app: App,
        changeDetectorRef: ChangeDetectorRef
    ) {
        super(checkoutFormComponent, checkoutStepComponent, app, changeDetectorRef);
    }

    get displayQuestions(): boolean {
        return !!(this.checkoutFormComponent.backendData.contains_furniture && this.data?.method);
    }

    get displayParcelInformation(): boolean {
        return !!(this.parcelNumber > 1);
    }

    get parcelNumber(): number | undefined {
        return this.checkoutFormComponent.backendData.shipping?.parcel_number;
    }

    handleModelChange(): void {
        this.onMethodPick();

        this.checkoutStepComponent.markUnsubmitted();
    }
}
